import { isEmpty, includes, orderBy, filter } from 'lodash-es';
import { TABS_IMAGES } from 'consts';

export const getCategories = (paymentMethodTypeCategories, paymentMethodTypes) => {
  const categories = isEmpty(paymentMethodTypeCategories)
    ? paymentMethodTypes
    : filter(paymentMethodTypes, item =>
        includes(paymentMethodTypeCategories, item.category)
      );

  return orderBy(categories, ['order', category => category.category.toLowerCase()]);
};

export const getCategoryPaymentMethodTypes = (categories, category) => {
  const relevantPaymentMethodTypes =
    categories.find(item => item.category === category)?.types || [];
  return orderBy(relevantPaymentMethodTypes, ['order', pmt => pmt?.name?.toLowerCase()]);
};

export const getPmtFallbackImageSrc = category => {
  const fallbackSrc = TABS_IMAGES[category];

  return fallbackSrc;
};

export const normalizePmtComingFromPreview = (
  previewCategories = [],
  previewPaymentMethodTypes = []
) => {
  return previewCategories?.reduce((acc, category, index) => {
    acc.push({
      category,
      order: index,
      types: previewPaymentMethodTypes?.filter(method => method.category === category)
    });
    return acc;
  }, []);
};
